import { render, staticRenderFns } from "./product-quick-sort.vue?vue&type=template&id=e32b15ba"
import script from "./product-quick-sort.vue?vue&type=script&lang=js"
export * from "./product-quick-sort.vue?vue&type=script&lang=js"
import style0 from "./product-quick-sort.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports